import { createAction } from '@reduxjs/toolkit';

export const knockBank = createAction('KNOCK_BANK');
export const receiveLoan = createAction('RECEIVE_LOAN');
export const resetGame = createAction('RESET_GAME');
export const setNextAvailableTapTime = createAction<number>('SET_NEXT_AVAILABLE_TAP_TIME');
